import React from "react";
import CommonDialog from "./CommonDialog";
import { DialogContentText, Typography } from "@mui/material";
import { DeleteDialogProps } from "../../utils/types";

const DeleteDialog = ({
  actionButton,
  cancelButton,
  dialogTextTitle,
  dialogSubTitle,
  title,
}: DeleteDialogProps) => {
  return (
    <CommonDialog
      title={title}
      cancelButton={cancelButton}
      actionButton={actionButton}
      actionButtonTitle="Yes"
      cancelButtonTitle="Cancel"
    >
      <DialogContentText>
        <Typography
          fontSize="13px"
          sx={{ color: "#000000", paddingBottom: 1, pl: 2 }}
        >
          {dialogTextTitle}
        </Typography>
        <Typography fontSize="12px" pl={2}>
          {dialogSubTitle}
        </Typography>
      </DialogContentText>
    </CommonDialog>
  );
};

export default DeleteDialog;
